<template>
  <div class="print">
    print
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>